import { render, staticRenderFns } from "./VoucherSettings.vue?vue&type=template&id=12459c74&scoped=true"
import script from "./VoucherSettings.vue?vue&type=script&lang=js"
export * from "./VoucherSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12459c74",
  null
  
)

export default component.exports